import React, { useState } from "react";
import PageHeader from "../../components/PageHeader";
import DeployTrigger from "../../components/DeployTrigger";
import Help from "../../components/Help";
import { helpPagesData } from "../../utils/helper";
import { useToast } from "../../components/ToastProvider";   // <--- moved to top
import { CreateNewOrganization } from "../../action/organizationaction"; // <--- moved to top
import { useNavigate } from "react-router-dom";


const AddOrganization = () => {
    const { showToast } = useToast();
    const navigate = useNavigate();

    const [form, setForm] = useState({
        name: "",
        email: "",
        contact: "",
        password: "",
    });

    const handleCreate = async () => {
        const res = await CreateNewOrganization(form);
        if (res?.data?.status === 1) {
            showToast("Organization created successfully", "success");
            navigate("/organization");
        } else {
            showToast(res?.message || "Failed to create organization", "error");
        }
    };

    return (
        <>
            <PageHeader pageTitle="Add Organization">
                    <Help
                        title={helpPagesData.pages.title}
                        message={helpPagesData.pages.message}
                        items={helpPagesData.pages.items}
                    />
            </PageHeader>

            <div className="page-container">
                <div className="theme-card p-4">
                    <label className="frm-label">Name</label>
                    <input
                        className="frm-input"
                        autoComplete="off"
                        placeholder="Enter Name"
                        value={form.name}
                        onChange={(e) => setForm({ ...form, name: e.target.value })}
                    />

                    <label className="frm-label mt-2">Email</label>
                    <input
                        className="frm-input"
                        autoComplete="new-email"
                        placeholder="Enter Email"
                        value={form.email}
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                    />

                    <label className="frm-label mt-2">Contact</label>
                    <input
                        className="frm-input"
                        value={form.contact}
                        autoComplete="new-email"
                        placeholder="Enter Contact Number"
                        onChange={(e) => setForm({ ...form, contact: e.target.value })}
                    />

                    <label className="frm-label mt-2">Password</label>
                    <input
                        className="frm-input"
                        type="password"
                        autoComplete="new-password"
                        placeholder="Enter Password"
                        value={form.password}
                        onChange={(e) => setForm({ ...form, password: e.target.value })}
                    />

                    <div className="header-btn-group mt-4">
                        <button className="btn-black ms-auto" onClick={handleCreate}>
                            Create
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddOrganization;
